"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
//Check if value follows a valid objectId pattern
var _default = exports["default"] = function _default(objectId) {
  return /^[0-9a-fA-F]{24}$/gi.test(objectId);
};